import { API } from "@aws-amplify/api";

export const getBolSignature = `query MyQuery($input: cidInput) {
  getBolSignature(input: $input) {
  fileName
  getUrl
  putUrl
  sequence
  }
  }`;

export async function getBolSignatures(params: any): Promise<any> {
  try {
    const response: any = await API.graphql({ query: getBolSignature, variables: { input: params } });
    return response.data.getBolSignature
  } catch (error) {
    console.log("getJourney", error);
  }
}
